import React from "react";
import { Container, Row, Col} from 'react-bootstrap'
import HeaderBlack from '../component/Header/HeaderBlack';
import Footer from "../component/Header/Footer";

function PortfolioBlack()
{
   return(
       <>
       <HeaderBlack/>
      <section id="app-clasic-faq-main-section">
          <div className="container">
              <div className="app-clasic-faq-text">
                  <h1>Privacy Policy</h1>
                  <p><span>Home </span> / Privacy Policy</p>
              </div>
          </div>
      </section>
      <section id="app-clasic-privacy-section">
        <Container>
        <p>This page outlines our policies regarding the collection, use, and disclosure of Personal 
           Information. By choosing to use our Service, you acknowledge that no personal information 
           is collected or saved by us. This Privacy Policy explains our commitment to not collecting 
           or storing your information.</p>

        <p>The terms used in this Privacy Policy have the same meanings as those in our Terms and 
           Conditions, available through the <span className="fcls-text">Modern AppForce</span> App, unless otherwise defined here.</p>   


        <div className="app-classic-terms-content" style={{paddingTop:"40px"}}>
          <h2>**Information Collection and Use**</h2>
          <p>- Our Service does not collect any personal information from its users. Therefore, we do not use or require any personal information for the use of our Service.</p>
        </div>

        <div className="app-classic-terms-content" style={{paddingTop:"40px"}}>
          <h2>**Log Data**</h2>
          <p>- We do not collect Log Data. Users can access and use our Service without concerns of their data being logged or stored.</p>
        </div>

        <div className="app-classic-terms-content" style={{paddingTop:"40px"}}>
          <h2>**Cookies**</h2>
          <p>- Our app does not use cookies directly. Since no personal information is collected, there are no cookies sent or stored on your device related to our Service.</p>
        </div>

        <div className="app-classic-terms-content" style={{paddingTop:"40px"}}>
          <h2>**Service Providers**</h2>
          <p>- We do not employ third-party companies or individuals for our Service. Therefore, there is no sharing, accessing, or use of your personal information by any third parties.</p>
        </div>

        <div className="app-classic-terms-content" style={{paddingTop:"40px"}}>
          <h2>**E-mail Contact**</h2>
          <p>- If you contact us via e-mail, we do not retain any personal data provided in your emails. Communication is solely for addressing your inquiries or feedback.</p>
        </div>

        <div className="app-classic-terms-content" style={{paddingTop:"40px"}}>
          <h2>**Security of Data**</h2>
          <p>- Our Service may contain links to other sites that are not operated by us. We advise you to review the Privacy Policy of these websites as we do not control and are not responsible for any content, privacy policies, or practices of any third-party sites or services.</p>
        </div>

        <div className="app-classic-terms-content" style={{paddingTop:"40px"}}>
          <h2>**Children's Privacy**</h2>
          <p>- Our Service does not target or collect information from anyone under the age of 15, as no personal information is collected from any user.</p>
        </div>

        <div className="app-classic-terms-content" style={{paddingTop:"40px"}}>
          <h2>**Updating This Privacy Policy**</h2>
          <p>- This Privacy Policy may be updated periodically to reflect any changes to our practices concerning the non-collection of personal information. We encourage you to review this page periodically for any updates.</p>
        </div>

        <div className="app-classic-terms-content" style={{paddingTop:"40px"}}>
          <h2>**Contact Us**</h2>
          <p>- If you have any questions or suggestions about our Privacy Policy, please do not hesitate to contact us at <a href="mailto:info@modernappforce.com"><strong>info@modernappforce.com</strong></a></p>
        </div>
        </Container>
        </section>
      
       <Footer/>
       </>
   )
}
export default PortfolioBlack;